import { LynxButton } from "components/LynxButton/LynxButton";
import React from "react";
import { toast } from "react-toastify";
import { useStore } from "store/StoreConfigs";
import { dismissPopupsButtonStyles } from "./DismissPopupsButtonStyles";

export function DismissPopupsButton() {
    const classes = dismissPopupsButtonStyles();
    const { commonStore } = useStore();

    const dismissAll = () => {
        toast.clearWaitingQueue();
        toast.dismiss();
        commonStore.clearPopupsCount();
    };

    return (
        <div className={classes.container}>
            <LynxButton onClick={dismissAll} className={classes.button}>
                Dismiss all
            </LynxButton>
        </div>
    );
}
